<template>
	<div class="yj-collapse-item" :class="{'is-active': isActive, 'is-disabled': disabled }">
		<div role="tab" :aria-expanded="isActive" :aria-controls="`yj-collapse-content-${id}`" :aria-describedby="`yj-collapse-content-${id}`">
			<div class="yj-collapse-item__header" @click="handleHeaderClick" role="button" :id="`yj-collapse-head-${id}`"
			 :tabindex="disabled ? undefined : 0" @keyup.space.enter.stop="handleEnterClick" :class="{
          'focusing': focusing,
          'is-active': isActive
        }"
			 @focus="handleFocus" @blur="focusing = false">
				<slot name="title">{{title}}</slot>
				<i class="yj-collapse-item__arrow yj-icon-arrowr" :class="{'is-active': isActive}">
				</i>
			</div>
		</div>
		<yj-collapse-transition>
			<div class="yj-collapse-item__wrap" v-show="isActive" role="tabpanel" :aria-hidden="!isActive" :aria-labelledby="`yj-collapse-head-${id}`"
			 :id="`yj-collapse-content-${id}`">
				<div class="yj-collapse-item__content">
					<slot></slot>
				</div>
			</div>
		</yj-collapse-transition>
	</div>
</template>
<script>
	import YjCollapseTransition from '@/components/collapse-transition';
	import Emitter from '@/mixins/emitter';
	import {
		generateId
	} from '@/utils/util';

	export default {
		name: 'YjCollapseItem',

		componentName: 'YjCollapseItem',

		mixins: [Emitter],

		components: {
			YjCollapseTransition
		},

		data() {
			return {
				contentWrapStyle: {
					height: 'auto',
					display: 'block'
				},
				contentHeight: 0,
				focusing: false,
				isClick: false,
				id: generateId()
			};
		},

		inject: ['collapse'],

		props: {
			title: String,
			name: {
				type: [String, Number],
				default () {
					return this._uid;
				}
			},
			disabled: Boolean
		},

		computed: {
			isActive() {
				return this.collapse.activeNames.indexOf(this.name) > -1;
			}
		},

		methods: {
			handleFocus() {
				setTimeout(() => {
					if (!this.isClick) {
						this.focusing = true;
					} else {
						this.isClick = false;
					}
				}, 50);
			},
			handleHeaderClick() {
				if (this.disabled) return;
				this.dispatch('YjCollapse', 'item-click', this);
				this.focusing = false;
				this.isClick = true;
			},
			handleEnterClick() {
				this.dispatch('YjCollapse', 'item-click', this);
			}
		}
	};
</script>



// WEBPACK FOOTER //
// src/components/collapse/src/collapse-item.vue